import { Navigate, RouteObject } from 'react-router-dom';
import { RoutePaths } from '@utils/route.utils.ts';
import { lazy, Suspense } from 'react';

const SignInComponent = lazy(() => import('./pages/sign-in/sign-in.tsx'));

export const authRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to={RoutePaths.Auth.SignIn.path} replace />
  },
  {
    path: RoutePaths.Auth.SignIn.path,
    element: (
      <Suspense>
        <SignInComponent />
      </Suspense>
    )
  },
  {
    path: '*',
    element: <Navigate to={RoutePaths.Auth.SignIn.path} replace />
  }
];
